import React from 'react';
import './OdServices.scss';
import OdButton from '../../OdButton/OdButton';

const OdServices = ({ data }) => {
  const { cta, ctaLink, services, bannerImage, bannerHeight, bannerWidth } = data;
  return (
    <div className="odServices">
      <div
        className="odServices__banner"
        style={{
          backgroundImage: `url(${bannerImage})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: bannerHeight,
          width: bannerWidth,
        }}
      />
      <div className="odServices__content">
        <div className="odServices__inner">
          {services?.map(service => (
            <div key={service.title} className="odServices__service">
              <img alt={service.title} className="odServices__image" src={service.imgSrc} />
              <div className="odServices__title">{service.title}</div>
              <div className="odServices__description">{service.description}</div>
            </div>
          ))}
        </div>
        <div className="odServices__cta">
          <OdButton href={ctaLink} label={cta} />
        </div>
      </div>
    </div>
  );
};

export default OdServices;
